import { connect } from 'react-redux';
import ThalamusAtlas from '../components/ThalamusAtlas';
import { updateCellPopulationChoice, addCellPopulationChoice, removeCellPopulationChoice } from '../actions/cell_population';

const mapStateToProps = state => ({
  cellPopulation: state.cellPopulation,
});

const mapDispatchToProps = dispatch => ({
  actions: {
    updateCellPopulationChoice: (target) => {
      dispatch(updateCellPopulationChoice(target));
    },
    addCellPopulationChoice: (target) => {
      dispatch(addCellPopulationChoice(target));
    },
    removeCellPopulationChoice: (target) => {
      dispatch(removeCellPopulationChoice(target));
    },
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ThalamusAtlas);



// WEBPACK FOOTER //
// ./src/containers/ThalamusAtlas.js